var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.0051995 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9966 8.81845 22.7312 5.76818 20.4815 3.51848C18.2318 1.26878 15.1816 0.00340334 12 0V0ZM18.0857 9.45685L11.586 15.9566C11.4932 16.0495 11.3829 16.1232 11.2616 16.1735C11.1403 16.2238 11.0102 16.2497 10.8789 16.2497C10.7475 16.2497 10.6174 16.2238 10.4961 16.1735C10.3748 16.1232 10.2645 16.0495 10.1717 15.9566L6.918 12.7071C6.73046 12.5196 6.6251 12.2652 6.6251 12C6.6251 11.7348 6.73046 11.4804 6.918 11.2929C7.10555 11.1053 7.35992 10.9999 7.62515 10.9999C7.89038 10.9999 8.14474 11.1053 8.33229 11.2929L10.8754 13.836L16.6689 8.04343C16.8564 7.85588 17.1108 7.75052 17.376 7.75052C17.6412 7.75052 17.8956 7.85588 18.0831 8.04343C18.2707 8.23097 18.3761 8.48534 18.3761 8.75057C18.3761 9.0158 18.2707 9.27017 18.0831 9.45771L18.0857 9.45685Z",
    fill: "#6FD231"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSvg);
export default __webpack_public_path__ + "static/media/SuccessSvg.85fc5b4827f0f7e879f718f32fa914d2.svg";
export { ForwardRef as ReactComponent };